import React from 'react';
import { ArrowRightIcon, CreditCardIcon } from 'lucide-react';
import { checkoutUrl } from '../data/content';
const lineItems = [{
  label: 'Manual integral Memorias del Alma™ (material digital completo)',
  value: '$ 84.950'
}, {
  label: '3 bonos estratégicos exclusivos',
  value: '$ 32.970'
}];
export function OfferBox() {
  return <section id="oferta" aria-labelledby="oferta-title" className="w-full bg-ink-raised" data-id="element-117" data-mp="1oofd9ynl06e4">
      <div className="mx-auto max-w-content px-5 py-10 sm:py-16 lg:py-24" data-id="element-118" data-mp="2cei5qfvered9">
        <div className="mx-auto max-w-3xl overflow-hidden rounded-2xl border border-amethyst/40 bg-ink sm:rounded-3xl" data-id="element-119" data-mp="2hbrrnljl97wc">
          <p className="bg-amethyst-deep px-5 py-2.5 text-center text-[11px] font-semibold uppercase tracking-[0.16em] text-cream sm:px-6 sm:py-3 sm:text-[12px] sm:tracking-[0.18em]" data-id="element-120" data-mp="23kwo8oruzj05">
            Oferta especial de lanzamiento
          </p>

          <div className="p-5 sm:p-10" data-id="element-121" data-mp="3032g7w1ud8l2">
            <h2 id="oferta-title" className="text-center font-display text-2xl text-cream sm:text-4xl" data-id="element-122" data-mp="304426vkebfhk">
              Pack Memorias del Alma™
            </h2>

            <dl className="mt-5 divide-y divide-line border-y border-line sm:mt-9" data-id="element-123" data-mp="30im3z0s987f7">
              {lineItems.map(item => <div key={item.label} className="flex items-baseline justify-between gap-4 py-3 sm:gap-6 sm:py-4" data-id="element-124" data-mp="3f8a9ke7gxs8q">
                  <dt className="text-[13px] leading-snug text-cream/85 sm:text-[15px]" data-id="element-125" data-mp="3o5kihswtd5ah">
                    {item.label}
                  </dt>
                  <dd className="shrink-0 font-sans text-[13px] tabular-nums text-muted sm:text-[15px]" data-id="element-126" data-mp="1znmd5y3yycy">
                    {item.value}
                  </dd>
                </div>)}
              <div className="flex items-baseline justify-between gap-4 py-3 sm:gap-6 sm:py-4" data-id="element-127" data-mp="23r0q3rocb07f">
                <dt className="text-[13px] font-semibold text-cream sm:text-[15px]" data-id="element-128" data-mp="23sv9h1jyqk9e">
                  Valor total
                </dt>
                <dd className="shrink-0 font-sans text-[13px] tabular-nums text-muted line-through sm:text-[15px]" data-id="element-129" data-mp="2pkr67yeqlic">
                  $ 117.920
                </dd>
              </div>
            </dl>

            <div className="mt-5 text-center sm:mt-9" data-id="element-130" data-mp="bp7q8n3nzf88">
              <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-amethyst sm:text-[12px] sm:tracking-[0.18em]" data-id="element-131" data-mp="brty6nugvwqz">
                Oportunidad única hoy
              </p>
              <p className="mt-2 font-display text-5xl leading-none text-gold sm:mt-3 sm:text-7xl" data-id="element-132" data-mp="llkjxkz7lt2z">
                $ 19
              </p>
              <p className="mt-2 text-[12px] text-muted sm:mt-3 sm:text-[14px]" data-id="element-133" data-mp="vcygpkzs0esf">
                o el equivalente en tu moneda local
              </p>
              <p className="mt-4 inline-flex items-center gap-2 rounded-2xl border border-line px-4 py-2 text-[12px] leading-snug text-cream/85 sm:mt-5 sm:rounded-full sm:text-[13px]" data-id="element-134" data-mp="zea5xpeqmy03">
                <CreditCardIcon className="h-4 w-4 shrink-0 text-amethyst" aria-hidden="true" data-id="element-135" data-mp="19drag3i975uh" />
                Pago único. Acceso de por vida. Sin mensualidades ni cobros recurrentes.
              </p>
            </div>

            <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="group mt-6 flex w-full items-center justify-center gap-2.5 rounded-full bg-gold px-5 py-4 text-center font-sans text-[14px] font-semibold leading-tight text-[#1B0F00] transition-[transform,background-color] duration-150 ease-out hover:bg-[#E8C480] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold active:scale-[0.99] sm:mt-8 sm:gap-3 sm:px-6 sm:text-[15px]" data-id="element-136" data-mp="1ek6acktlt3r1">
              Obtener el Sistema Memorias del Alma™
              <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-137" data-mp="2ky5l3t7wfj26" />
            </a>

            <p className="mt-4 text-center text-[12px] leading-relaxed text-muted sm:mt-5 sm:text-[13px]" data-id="element-138" data-mp="20ow99qekl847">
              Descarga inmediata · Pago seguro · Acceso de por vida · Garantía de 7 días
            </p>
          </div>
        </div>
      </div>
    </section>;
}